import {store} from "../store/store";

export const NutrientDetailsProvider = {
    getById(id) {
        return store.state.dictionaries.nutrients.find((nutrient) => {
            return nutrient.id === Number(id);
        });
    },
    sortNutrients(nutrients) {
        return nutrients.sort((nutrientA, nutrientB) => {
            if (nutrientA.groupId === nutrientB.groupId) {
                return nutrientA.position < nutrientB.position ? -1 : 1;
            }

            return nutrientA.groupId < nutrientB.groupId ? -1 : 1;
        });
    }
};

export const PROTEIN = 1;
export const FATS = 2;
export const CARBO = 3;
export const KCAL = 5;
export const FIBER = 20;
export const CHOLESTEROL = 89;
export const FATTYACIDS = 119;
export const WW = 153;
export const WBT = 154;
export const GLICEMIC_INDEX = 156;
export const GLICEMIC_LOAD = 157;
export const BASIC_GROUP_IDS = [PROTEIN, FATS, CARBO];
export const OTHER_GROUP_IDS = [FIBER, CHOLESTEROL, FATTYACIDS];
